import { Button, Card, Text, VerticalStack } from "@shopify/polaris";
import { adminRoutePrefix } from "@smartrr/shared/constants";
import React from "react";

import { navigateWithShopInQuery } from "@vendor-app/utils/navigateWithShopInQuery";

export function LoyaltyUpsellCard(): JSX.Element {
  return (
    <Card>
      <VerticalStack gap="400">
        <Text variant="headingMd" as="h2">
          Double your LTV with Smartrr Loyalty
        </Text>
        <Text as="p" variant="bodyMd" color="subdued">
          Subscribers who redeem loyalty points see 88% higher CLTV on average. Combine Subscriptions + Loyalty to
          unlock faster, more sustainable growth.{" "}
          <Text as="span" fontWeight="bold">
            Contact your CSM
          </Text>{" "}
          to learn more or begin setup by clicking{" "}
          <Text as="span" fontWeight="bold">
            Get Started
          </Text>
          .
        </Text>
        <div style={{ alignSelf: "flex-start" }}>
          <Button primary onClick={() => navigateWithShopInQuery(`${adminRoutePrefix}/loyalty`)}>
            Get started
          </Button>
        </div>
      </VerticalStack>
    </Card>
  );
}
